// The live voice call with an employee (Gemini Live), shown in place of the message box while the call is on.
// The words both sides say show as captions; whatever the employee looks up or drafts lands in the chat above.
import { useEffect, useState } from 'react';
import Avatar from '../Avatar';

const STATE = {
  connecting: () => 'Calling…',
  listening: () => 'Listening · talk any time, in Bangla or English',
  speaking: (n) => `${n} is talking · just talk to interrupt`,
  working: (n) => `${n} is checking the system…`,
};

const mmss = (ms) => { const s = Math.max(0, Math.floor(ms / 1000)); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`; };

export default function CallPanel({ agent, call, captions, onEnd, onMute }) {
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((n) => n + 1), 1000); return () => clearInterval(t); }, []);
  const label = (STATE[call.state] || STATE.listening)(agent.name);
  return (
    <div className={`callpanel ${call.state}`} role="region" aria-label={`Call with ${agent.name}`}>
      <div className="call-top">
        <div className="call-face"><Avatar agent={agent} /><i /></div>
        <div className="call-who">
          <b>On call with {agent.name}</b>
          <span>{call.startedAt ? mmss(Date.now() - call.startedAt) : '…'} · {label}</span>
        </div>
      </div>
      {(captions.boss || captions.agent) && (
        <div className="call-caps" aria-live="polite">
          {captions.boss && <p className="me"><small>You</small>{captions.boss}</p>}
          {captions.agent && <p><small>{agent.name}</small>{captions.agent}</p>}
        </div>
      )}
      <div className="call-a">
        <button type="button" className="aio-btn" onClick={onMute} aria-pressed={call.muted}>{call.muted ? 'Unmute' : 'Mute'}</button>
        <button type="button" className="aio-btn endcall" onClick={onEnd}>End call</button>
      </div>
    </div>
  );
}
